import ShowMoreText from 'react-show-more-text'
import 'src/schedule/views/event/custom_events/style.css'

interface ReadMoreViewProps {
  description: string
  onPressReadMore: React.Dispatch<React.SetStateAction<boolean>>
}

export function ReadMoreView({
  description,
  onPressReadMore,
}: ReadMoreViewProps) {
  return (
    <ShowMoreText
      lines={2}
      more={'See more'}
      className="read-more"
      anchorClass="show-more-less-clickable"
      expanded={false}
      expandByClick={false}
      onClick={(expanded: boolean) => onPressReadMore(true)}
    >
      {description}
    </ShowMoreText>
  )
}
